const state = {
  tips: [] // 消息提示列表
}

const mutations = {
  add: (state, msg) => {
    state.tips.push(msg)
  },
  clear: (state) => {
    state.tips = []
  }
}

const actions = {
  add({ commit }, tip) {
    commit('add', tip)
  },
  clear({ commit }) {
    commit('clear')
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/tip.js